import { render, staticRenderFns } from "./delivery-method-card.vue?vue&type=template&id=168cec5b&scoped=true&lang=pug"
import script from "./delivery-method-card.vue?vue&type=script&lang=ts"
export * from "./delivery-method-card.vue?vue&type=script&lang=ts"
import style0 from "./delivery-method-card.vue?vue&type=style&index=0&id=168cec5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168cec5b",
  null
  
)

export default component.exports